export default __webpack_public_path__ + "static/media/struct4.18d16057.png";